<template>
<div class="h-fit">
  <div class="relative w-full max-w-[800px] flex flex-col mt-4 mb-4 sm:mt-6 mx-auto sm:mb-6" >
    <img :src="imgUrl($mecanic.background_img_bandit, 'bandit')" alt="" class="w-full max-w-[800px] z-1" style ="left: 0;right: 0;margin: auto;">
    <div class="absolute doors mx-auto z-10 mt-[43.5%] left-[30%] w-[40.5%] h-[11%]">
      <div v-for="door in doors" :key="door" class="door">
        <img :src="door" alt="">
        <div class="boxes">
        </div>
      </div>
    </div>
    
  </div>

  <div class="relative w-full max-w-[800px] flex flex-col mx-auto mb-4 sm:mb-6 px-4">
    <div v-if="!endSpin && !isLoading" class="w-full flex justify-center pb-10">
      <button class="button-validation lg:!p-4 button-play mx-auto text-lg sm:text-4xl" @click="spin()" id="spinner">{{$mecanic.button_text_bandit}}</button>
    </div>

    <div v-if="endSpin" class="w-full flex flex-col justify-center">
      <p v-if="isFirst" class="mb-4" v-html="$mecanic.end_text_bandit"></p>
      <p v-else class="mb-4" v-html="tagText($mecanic.end_product_text_bandit)"></p>
      <p class="m-auto w-fit sm:mt-4 font-bold text-[14px] lg:text-[24px]">{{isFirst ? 'Voici votre numéro de participation' : 'Voici votre 2ème numéro de participation !'}}</p>
      <CodeTable v-if="code" :code="code" />
      <!-- <button v-if="!isGameFinish && !alreadyPlay"  class="button-validation lg:!p-3 button-end w-fit mx-auto !mt-4" @click="endGame()" id="spinner">{{$mecanic.validate_text_bandit}}</button> -->
    </div>
  </div>
</div>
</template>

<script>
import CodeTable from './CodeTable.vue'
export default {
  emits: ['endGame'],
  components : {
    CodeTable
  },
  props : {
    code : String,
    alreadyPlay : Boolean,
    isFirst : Boolean
  },
  data() {
    return {
      doors: 3,
      items : [],
      endSpin : false,
      isGameFinish: false,
      isLoading: false,
    }
  },
  computed: {
    code1() {
      return this.$store.participationCode1 ?? null
    },
    code2() {
      return this.$store.participationCode2 ?? null
    }
  },
  methods: {
    endGame() {
      this.isGameFinish = true
      this.$emit('endGame')
      
      if (!this.alreadyPlay) {
        this.scrollAuto = setTimeout(() => {
          window.scrollBy({
            top: 150, 
            behavior: 'smooth'
          });
        }, "1000");
        
        document.addEventListener("scroll", this.clearTimeout);
      }
    },
    clearTimeout() {
      clearTimeout(this.scrollAuto)
      document.removeEventListener('scroll', this.clearTimeout);
    },
    init(firstInit = true, groups = 1, duration = 1) {
      const doors = document.querySelectorAll('.door');
      for (const [doorIndex,door] of doors.entries()) {
        if (firstInit) {
          door.dataset.spinned = '0';
        } else if (door.dataset.spinned === '1') {
          return;
        }

        const boxes = door.querySelector('.boxes');
        const boxesClone = boxes.cloneNode(false);
        const pool = [this.$mecanic.loose_1_img_bandit,this.$mecanic.loose_2_img_bandit,this.$mecanic.loose_3_img_bandit];

        if (!firstInit) {
          const arr = [];
          for (let n = 0; n < (groups > 0 ? groups : 1); n++) {
            arr.push(...this.items);
          }
          
          pool.push(...this.shuffle(arr));
          pool[0] = (doorIndex === 0  ? this.$mecanic.loose_1_img_bandit : ( doorIndex === 1 ? this.$mecanic.loose_2_img_bandit : this.$mecanic.loose_3_img_bandit))
        }

        for (let i = pool.length - 1; i >= 0; i--) {
          const box = document.createElement('div');
          const img = document.createElement('img');
          if (firstInit) {
            img.src = this.imgUrl(pool[doorIndex], 'bandit')
          } else {
            img.src = this.imgUrl(pool[i], 'bandit')
          }
          img.classList.add('img');
          
          box.style.width  = '100%';
          box.style.height  = '100%';
          box.style.display  = 'flex';

          img.style.width  = '100%';
          img.style.height  = 'auto';
          // img.style.maxWidth  = '68px';
          // img.style.maxHeight = '85px';
          img.style.margin = 'auto';
          box.appendChild(img);

          img.textContent = pool[i];
          boxesClone.appendChild(box);
        }
        boxesClone.style.transitionDuration = `${duration > 0 ? duration : 1}s`;
        boxesClone.style.transform = `translateY(-${door.clientHeight * (pool.length - 1)}px)`;
        door.replaceChild(boxesClone, boxes);
      }
    },
    async spin() {
      this.isLoading = true
      this.init(false, 4, 5);
      const doors = document.querySelectorAll('.door');

      for (const door of doors) {
        const boxes = door.querySelector('.boxes');
        const duration = parseInt(boxes.style.transitionDuration);
        boxes.style.transform = 'translateY(0)';
        await new Promise((resolve) => setTimeout(resolve, duration * 100));
      }
      setTimeout(() => {
        this.endSpin = true
        this.isLoading = false
        this.endGame()
      }, "4500");
    },
    shuffle([...arr]) {
      let m = arr.length;
      while (m) {
        const i = Math.floor(Math.random() * m--);
        [arr[m], arr[i]] = [arr[i], arr[m]];
      }
      arr[arr.length-1] = this.items[0]
      return arr;
    }
  },
  mounted() {
    this.items = [
      this.$mecanic.win_img_bandit,
      this.$mecanic.loose_1_img_bandit,
      this.$mecanic.loose_2_img_bandit,
      this.$mecanic.loose_3_img_bandit,
    ]
    this.init()

    if (this.alreadyPlay) {
      this.spin()
      this.endSpin = true
      this.endGame()
    }
  },
}
</script>

<style scoped>
.doors {
  display: flex;
  justify-content: space-around;
}

.door {
  background: #fafafa;
  overflow: hidden;
  /* @apply w-[68px] h-[85px] m-[19.5px] */
  @apply w-[21%] h-[100%]
}

.boxes {
  transition: transform 1s ease-in-out;
  /* @apply w-[68px] h-[85px] */
  @apply w-[100%] h-[100%]
}

.button-play {
  background-color: v-bind(
    "$mecanic ? $mecanic.button_background_bandit : ''"
  );
  color: v-bind("$mecanic ? $mecanic.button_color_bandit : ''");
}
.button-end {
  background-color: v-bind(
    "$mecanic ? $mecanic.validate_background_bandit : ''"
  );
  color: v-bind("$mecanic ? $mecanic.validate_color_bandit : ''");
}
</style>
